import { Button, Dialog, DialogContent } from "@/shared";
import { Dropdown, DropdownItem } from "@/shared/components/ui/Dropdown";
import { useTranslation } from "react-i18next";

const ItemFilterDialog = ({ dialog, onCloseDialog, setDisplayReport, setDialog }: any) => {
    const { t } = useTranslation();
    return (
        <Dialog open={dialog.open} onOpenChange={onCloseDialog}>
            <DialogContent
                onClose={onCloseDialog}
                className="max-w-md p-0 overflow-hidden rounded-2xl">
                <div className="p-8 space-y-6">
                    <div className="space-y-3">
                        {/* <label className="text-sm font-black text-slate-500 uppercase tracking-wider">
                            {t("layout_type")}
                        </label> */}
                        <Dropdown
                            label={dialog.layoutType ? t(dialog.layoutType) : t("layout_type")}
                        >
                            <DropdownItem onClick={() => setDialog((prev: any) => ({ ...prev, layoutType: 'Standard Layout' }))}>{t("Standard Layout")}</DropdownItem>
                            <DropdownItem onClick={() => setDialog((prev: any) => ({ ...prev, layoutType: 'Grouped Layout' }))}>{t("Grouped Layout")}</DropdownItem>
                        </Dropdown>
                    </div>
                </div>

                <div className="p-6 bg-slate-50 border-t border-slate-100 flex gap-3">
                    <Button
                        className="flex-1 bg-violet-600 hover:bg-violet-700 text-white shadow-lg shadow-violet-200"
                        onClick={() => {
                            setDisplayReport(dialog.layoutType)
                            onCloseDialog();
                        }}
                    >
                        {t("apply")}
                    </Button>
                    <Button
                        variant="outline"
                        className="flex-1 border-slate-200 text-slate-600 hover:bg-slate-100"
                        onClick={onCloseDialog}
                    >
                        {t("cancel")}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default ItemFilterDialog;